
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Tooltip, Icon } from 'element-ui';

@Component({
  components: {
    Tooltip,
    Icon,
  },
})
export default class ListItem extends Vue {
  @Prop() chapter?: any;

  @Prop() curCid?: string;
}
